import React from "react";
import { PageTitle } from "../../../../_metronic/layout/core";
import GenericReport from "../GenericReport";

const VehicleModelPage: React.FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={[{ title: "Reports", path: "/reports", isActive: false }]}>
        Vehicle Model Report
      </PageTitle>
      <GenericReport reportId={14} />
    </>
  );
};

export default VehicleModelPage;
